import React, { useEffect } from "react";
import $ from "jquery";
import "../styles/popup.scss";
import { graphql } from "gatsby";
import FastLinks from "../components/FastLinks";
import Patterns from "../container/Patterns.js";
import AccountList from "../components/AccountList";
import ServiceList from "../components/ServiceList";
import PlainCards from "../components/PlainCards";
import FeatureCards from "../components/FeatureCards";
import CardSlider from "../components/CardSlider";
import SearchResults from "../components/SearchResults";
import NewsList from "../components/NewsList";
import Paging from "../components/Paging";
import QuickFAQ from "../components/QuickFAQ";
import { usePageContext } from "../utils/PageContext";
import BusinessNeeds from "../components/BusinessNeeds";
import SystemMessages from "../components/SystemMessages";

export default function Home({ data }) {
  const { changeArticleType } = usePageContext();

  const body = data.api.home.body;

  useEffect(() => {
    /* Popup attention grabber function */
    // $(function () {
    //   var overlay = $('<div id="overlay"></div>');
    //   overlay.show();
    //   overlay.appendTo(document.body);
    //   $(".popup").show();
    //   $(".close").click(function () {
    //     $(".popup").hide();
    //     overlay.appendTo(document.body).remove();
    //     return false;
    //   });
    // });
    /* End of popup function */

    changeArticleType("INDIVIDUAL");
  }, []);

  return (
    <>
      {/* <div className="popup">
        <div className="popupint">
          <a href="" className="close"></a>
          <center>
            <strong>
              <p>
                DATAT E PROVIMIT TË PRANIMIT NË SHKOLLËN E MAGJISTRATURËS PËR
                VITIN AKADEMIK 2022-2023
              </p>
            </strong>
          </center>
          <br />
          <p className="popupsmall">
            <strong>Faza e II:</strong> 25 Prill 2022 / Ora 08:00
          </p>
        </div>
      </div> */}

      <div className="wrapper home">
        <Patterns data={body} />
      </div>
    </>
  );
}

export const pageQuery = graphql`
  query {
    api {
      home {
        body {
          __typename

          ... on API_ComponentArticlePatternBodyMainSlider {
            id
            slides {
              id
              image {
                url
              }
              textAlign
              title {
                id
                text_sq
                text_en
              }
              description {
                id
                text_sq
                text_en
              }
              article {
                slug
                category {
                  slug
                  parentCategory {
                    slug
                    parentCategory {
                      slug
                    }
                  }
                }
              }
            }
          }

          ... on API_ComponentArticlePatternBodyHeader {
            headerAlignment: alignment
            text {
              id
              text_sq
              text_en
            }
          }

          ... on API_ComponentArticlePatternBodyAlert {
            id
            title {
              id
              text_sq
              text_en
            }
            content {
              id
              text_sq
              text_en
            }
            type
          }

          ... on API_ComponentArticlePatternBodyBannerWithText {
            id
            mobileScreen {
              url
              formats
            }
            desktopScreen {
              url
              formats
            }
            title {
              id
              text_sq
              text_en
            }
            description {
              id
              text_sq
              text_en
            }
            textColor
            links {
              id
              label {
                id
                text_sq
                text_en
              }
              backgroundColor
              textColor
              url
              article {
                slug
                category {
                  slug
                  parentCategory {
                    slug
                    parentCategory {
                      slug
                    }
                  }
                }
              }
              icon {
                id
                position
                icon
              }
            }
            tags {
              id
              label {
                text_sq
                text_en
              }
              backgroundColor
              textColor
            }
          }

          ... on API_ComponentArticlePatternBodySimpleBanner {
            id
            title {
              id
              text_sq
              text_en
            }
            subtitle {
              id
              text_sq
              text_en
            }
            mobileScreen {
              url
              formats
            }
            desktopScreen {
              url
              formats
            }
            textColor
          }

          ... on API_ComponentArticlePatternBodyLetter {
            letter: text {
              id
              text_sq
              text_en
            }
          }
          ... on API_ComponentArticlePatternBodyCollapsible {
            items {
              id
              title {
                id
                text_sq
                text_en
              }
              body {
                id
                text_sq
                text_en
              }
            }
          }
          ... on API_ComponentArticlePatternBodyDigitalPlatforms {
            __typename
          }

          ... on API_ComponentArticlePatternBodyPartners {
            __typename
          }

          ... on API_ComponentArticlePatternBodyBubbleBlock {
            id
            title {
              id
              text_sq
              text_en
            }
            description {
              id
              text_sq
              text_en
            }
            items {
              id
              text_sq
              text_en
            }
            video_url
            image {
              url
            }
            color
            alignment
            article {
              slug
              category {
                ...ArticleCategoryFragment
              }
            }
          }
          ... on API_ComponentArticlePatternBodyUsefulLinks {
            column2 {
              title {
                text_sq
                text_en
              }
              body {
                text_sq
                text_en
              }
            }
            column3 {
              title {
                text_sq
                text_en
              }
              body {
                text_sq
                text_en
              }
            }
            links {
              type
              uri
              article {
                slug
                category {
                  ...ArticleCategoryFragment
                }
              }
              category {
                slug
                parentCategory {
                  ...Category
                  slug
                  title {
                    id
                    text_en
                    text_sq
                  }
                  parentCategory {
                    ...Category
                    slug
                    title {
                      id
                      text_en
                      text_sq
                    }
                    parentCategory {
                      ...Category
                      title {
                        id
                        text_en
                        text_sq
                      }
                      slug
                      parentCategory {
                        ...Category
                        slug
                        title {
                          id
                          text_en
                          text_sq
                        }
                      }
                    }
                  }
                }
              }
              label {
                id
                text_sq
                text_en
              }
            }
          }
        }
      }
    }
  }
`;
